import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CopyIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { handleCopy } from '@rsos/components/capstone/Location/helpers/handleCopy';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import { handleClipboardData } from '@rsos/utils/handleClipboardData';
import { CopyButton } from './AlertsCopyAllButton.styles';
import { getAlertLocationData, getCopyableADR } from './helpers';

const WHAT_3_WORDS = 'WHAT3WORDS';

const AlertsCopyAllButton = () => {
  const permissions = useSelector(state =>
    selectUserPermissionsByApp(state.sinatra.user, 'capstone'),
  );

  const hasWhat3wordsAccess = permissions?.includes(WHAT_3_WORDS);
  const incidents = useSelector(state => state.incidents);

  const selectedAlertID = incidents.selectedAlertID;
  const selectedAlert = incidents.alerts[selectedAlertID];
  const isAlertLoading = incidents.loading.alert;
  const geodetic = selectedAlert?.location_history?.[0]?.geodetic;

  const alertAdr = useSelector(
    state => state.adrData.data?.[`alert://${selectedAlertID}`]?.data,
  );

  const what3words = useSelector(
    state =>
      state.what3words.alerts?.[selectedAlertID]?.[
        `${geodetic?.latitude}_${geodetic?.longitude}`
      ]?.words,
  );

  const modifiedWhat3Words = hasWhat3wordsAccess ? what3words : null;

  const locationData = useMemo(
    () => getAlertLocationData(selectedAlert, modifiedWhat3Words),
    [modifiedWhat3Words, selectedAlert],
  );

  const { irpVersion } = useSelector(state => state.sinatra.irp);

  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    const clipboardLocationData = handleClipboardData(locationData);
    const clipboardADR = getCopyableADR(alertAdr);
    const fullClipboardText = clipboardADR
      ? `${clipboardLocationData}\n${clipboardADR}`
      : clipboardLocationData;

    handleCopy({
      value: fullClipboardText,
      name: 'Lat and Long',
      irpVersion,
      onStart: () => setIsActive(true),
      onEnd: () => setIsActive(false),
    });
  };

  useEffect(() => {
    setIsActive(false);
  }, [selectedAlertID]);

  return !isAlertLoading ? (
    <CopyButton isActive={isActive} onClick={handleClick}>
      <CopyIcon />
      <Text ml={'5px'} size="xsmall">
        {isActive ? 'Copied' : 'Copy All'}
      </Text>
    </CopyButton>
  ) : null;
};

export default AlertsCopyAllButton;
